<template>
  <span class="textalign">
        <el-tooltip class="item" effect="dark" content="RUN NOW" placement="top-end">
            <i v-if="displayType=='icon'"
                @click="handleNow()"
                class="el-icon-upload runNowIcon">
            </i>
            <el-button
                @click="handleNow()"
                class="rightMrg"
                type="danger"
                v-else>
                Run now
            </el-button>
        </el-tooltip>  
    <el-dialog
      title="Run this bot right now"
      :visible.sync="dialogNow.visible"
      width="400px"
      :before-close="handleCloseNow">
      <div class="inputContainerNow">
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Delay
          </el-col>
          <el-col :span="12">
            <el-input-number size="mini" :step="1" v-model="dialogNow.delay"></el-input-number>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Tasks
          </el-col>
          <el-col :span="12">
            <el-input-number size="mini" :step="5" v-model="dialogNow.tasks"></el-input-number>
          </el-col>
          </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
              Repeats
          </el-col>
          <el-col :span="12">
            <el-input-number size="mini" :step="50" v-model="dialogNow.repeats"></el-input-number>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Playbook id
          </el-col>
          <el-col :span="12">
            <el-input class="playbookId" size="mini" :width="50" :step="50" v-model="dialogNow.playbook_id"></el-input>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Retry count
          </el-col>
          <el-col :span="12">
            <el-input-number size="mini" :width="50" :step="1" v-model="dialogNow.retry_num"></el-input-number>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-divider><i class="el-icon-star-on"></i></el-divider>
          <el-col :span="12" class="nameCol">
            Record video:
          </el-col>
          <el-col :span="12" class="nameCol">
            <el-switch
              v-model="dialogNow.video_ratio"
              >
            </el-switch>
          </el-col>
        </el-row>
        <el-row>

        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseNow()">Cancel</el-button>
        <el-button icon="el-icon-danger" type="primary" @click="runBotNow(dialogNow.bot_id)">RUN</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
export default {
    name: 'RunNow',
    components: {
        
    },
    props: {
        bot_id: {
            type: Number,
            default: () => null
        },
        project_id: {
            type: Number,
            default: () => null
        },
        displayType: {
            type: String,
            default: () => 'icon'
        }
    },
    data () {
        return {
            dialogNow: {
              visible: false,
              delay: 1,
              tasks: 1,
              repeats: 1,
              bot_id: -1,
              project_id:-1,
              video_ratio: false,
              playbook_id: 0,
              retry_num:0
            },
        }
    },
    methods: {
        runBotNow() {
            var ratio = (this.dialogNow.video_ratio == true) ? 100 : 0; 
            this.$store.dispatch('project/scheduleBotNow', {
            project_id:this.project_id,
            bot_id: this.bot_id,
            delay: this.dialogNow.delay,
            repeats: this.dialogNow.repeats,
            tasks: this.dialogNow.tasks,
            playbook_id: this.dialogNow.playbook_id,
            video_ratio: ratio,
            retry_num: this.dialogNow.retry_num
            });
        },
        handleCloseNow() {
            this.dialogNow.visible = false;
        },
        handleNow() {
            this.dialogNow.visible = true;
            this.dialogNow.bot_id = this.bot_id
            this.dialogNow.project_id = this.project_id;
        }, 
    },
    mounted: function () {
        var that = this;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'project/BOT_RAN_NOW') {
              this.dialogNow.visible = false;
            }
        })
    },
    computed: {
      ...mapState('project', {
          loading: 'loading',
          stats: 'stats'
        }),
        
    },
}
</script>

<style lang="scss" scoped>
    .textalign{
        text-align: left;      
    }
    .runNowIcon{
        margin-top:15px;
        cursor: pointer;
    }
    .rightMrg{
        margin-right:10px;
    }
</style>
